<script lang="ts">
    import Box from '../_DisplayComponents/_wrappers/Box.svelte';

    import Link from './Link.svelte';
    import Animation from './Animation.svelte';
    import Connector from './Connector.svelte';
    import { insertIntoArray, isDark } from '$lib/helper';
    import { base } from '$app/paths';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { ComponentType } from 'svelte';
    import type { Box as BoxType } from '$lib/types/Component';

    export let legalLink: string;
    export let legalText: string;
    export let termsLink: string;
    export let termsText: string;
    export let claimText = 'We use Perspective';
    export let bgColorReference = '#FFFFFF';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let branding = true;
    export let utmParams = '';
    export let language = 'de';
    export let hasCookies: boolean;
    export let box: BoxType;

    const logo = 'https://perspective.imgix.net/assets/app/logo/32x32.png?dpr=2&auto=compress&q=75';

    //Create Links
    let linkComponents: [ComponentType, string, string][] = [];

    if (legalLink && legalText) {
        linkComponents.push([Link, legalText, legalLink]);
    }

    if (termsLink && termsText) {
        linkComponents.push([Link, termsText, termsLink]);
    }

    linkComponents = insertIntoArray(linkComponents, [Connector]);

    $: dark = isDark(bgColorReference);
</script>

<Box {...box} backgroundColor={bgColorReference} {transitionDelay} {transitionEffect}>
    <div class="flex h-full items-center justify-center font-ui text-sm font-normal">
        <div class="flex flex-col items-center">
            {#if linkComponents.length > 0}
                <div
                    class="text-center text-xs {dark ? 'text-white/50' : 'text-black/50'}"
                    class:pb-6={branding}
                >
                    {#each linkComponents as [component, text, link]}
                        <svelte:component this={component} {text} {link} />{' '}
                    {/each}
                    {#if hasCookies}
                        <Connector />
                        <a
                            href={`${base}/consent-policy`}
                            class="inline cursor-pointer font-ui underline"
                        >
                            {language === 'de' ? 'Cookie Richtlinien' : 'Cookie Policy'}
                        </a>
                    {/if}
                </div>
            {/if}
            {#if branding}
                <div>
                    <a
                        href={`https://perspective.co${utmParams}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        class="relative flex items-center rounded-md py-2.5 px-3 font-ui no-underline {dark
                            ? 'bg-white/20'
                            : 'bg-black/5'}"
                    >
                        <Animation />
                        <img src={logo} alt="logo" class="mr-3 w-5" />
                        <span class={dark ? 'text-white/50' : 'text-black/50'}>{claimText}</span>
                    </a>
                </div>
            {/if}
        </div>
    </div>
</Box>
